module.exports = __webpack_public_path__ + "static/img/no_result.67a6aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Action/no_result.png
// module id = 300
// module chunks = 0